import { useCallback } from 'react';
import { fetchPostData } from '@/Components/hooks/Api';
import { changeArrayFormat } from '@/Components/Common/Utility';

const useReportPendingApproval = ({
  setcheckWebWorkFlowStatus,
  setapproverRequiredCount,
  setGroupList,
  setnarrativeData,
  setApprovedNarrativeData,
  setRejectedNarrativeData,
  setfilteredData,
  setLoginUserGroupList,
  parseAllComments,
}) => {
  // GET_DATA_REPORT_WORK_LEVEL_CHECK
  const GetData_ReportWorkLevelCheck = useCallback((loginAgencyID, narrativeID) => {
    const val = { AgencyID: loginAgencyID, NarrativeID: narrativeID };

    fetchPostData('IncidentNarrativeReport/GetData_ReportWorkLevelCheck', val).then((res) => {
      if (res && res.length > 0) {
        const workflowData = res[0];
        const canShowApprovalButton = workflowData?.IsMultipleLevel;
        setcheckWebWorkFlowStatus(canShowApprovalButton);
        setapproverRequiredCount(workflowData?.ReportApproverRequired);
      }
    });
  }, [setapproverRequiredCount, setcheckWebWorkFlowStatus]);

  // GET_DATA_REPORT_WORK_LEVEL_CHECK_USE_OF_FORCE
  const GetData_ReportWorkLevelCheck_UseOfForce = useCallback((loginAgencyID, useOfForceID) => {
    const val = { AgencyID: loginAgencyID, UseofForceID: useOfForceID };

    fetchPostData('IncidentNarrativeReport/GetData_ReportWorkLevelCheck', val).then((res) => {
      if (res && res.length > 0) {
        console.log(res);
        const workflowData = res[0];
        const canShowApprovalButton = workflowData?.IsMultipleLevel;
        setcheckWebWorkFlowStatus(canShowApprovalButton);
        setapproverRequiredCount(workflowData?.ReportApproverRequired);
      }
    });
  }, [setapproverRequiredCount, setcheckWebWorkFlowStatus]);

  // GET_GROUP_LIST
  const get_Group_List = useCallback((loginAgencyID, loginPinID, NarrativeID) => {
    const value = { AgencyId: loginAgencyID, PINID: loginPinID, NarrativeID };
    fetchPostData('Group/GetData_Grouplevel', value).then((res) => {
      if (res) {
        setGroupList(changeArrayFormat(res, 'group', 'Level'));
      } else {
        setGroupList();
      }
    });
  }, [setGroupList]);

  // GET_DATA_NARRATIVE
  const get_Data_Narrative = useCallback((NarrativeID) => {
    const val = { NarrativeID };
    fetchPostData('IncidentNarrativeReport/GetData_Narrative', val).then((res) => {
      if (res) {
        const normalizedRows = res.map((item) => ({
          ...item,
          AllComments: parseAllComments(item?.AllComments),
        }));
        setnarrativeData(normalizedRows);
        const approvedData = normalizedRows.filter((item) => item.IsApprove === true);
        const rejectedData = normalizedRows.filter((item) => item.IsReject === true);
        setApprovedNarrativeData(approvedData);
        setRejectedNarrativeData(rejectedData);
        setfilteredData(normalizedRows);
      } else {
        setnarrativeData([]);
      }
    });
  }, [parseAllComments, setApprovedNarrativeData, setRejectedNarrativeData, setfilteredData, setnarrativeData]);

  // GET_PERSONNEL_GROUP_DETAILS
  const GetPersonnelGroupDetails = useCallback((PINID, loginAgencyID) => {
    const val = { PINID, AgencyID: loginAgencyID };
    fetchPostData('SecurityGroupUserMembers/GetPersonnelGroupDetails', val).then((res) => {
      if (res) setLoginUserGroupList(res);
      else setLoginUserGroupList([]);
    });
  }, [setLoginUserGroupList]);

  return {
    GetData_ReportWorkLevelCheck,
    GetData_ReportWorkLevelCheck_UseOfForce,
    get_Group_List,
    get_Data_Narrative,
    GetPersonnelGroupDetails,
  };
};

export default useReportPendingApproval;
